export default "__VITE_ASSET__BGZmEh1M__"